// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
function InjectCSS(Props) {
  var css = Props.css;
  return React.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: css
    }
  });
}
InjectCSS.displayName = "InjectCSS";
var make = InjectCSS;
export { make };
/* react Not a pure module */